import React, { useEffect, useRef, useState } from "react";
import TransactionsTransactionStatSection from "./TransactionsTransactionStatSection";
import CommonPaginationSection from "../../../components/common/CommonPaginationSection";
import TransactionTransactionsSearchSection from "./TransactionTransactionsSearchSection";
import moment from "moment";
import TransactionTransactionsList from "./TransactionTransactionsList";
import getTransactions from "../../../controllers/booking/Transactions.js/getTransactions";
import axios from "axios";
import { transactionsTableData } from "../../../data/order/transactionsTableData";

function TransactionTransactionsSection() {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [timeFilter, setTimeFilter] = useState({
    range: "all",
    date: moment().toString(),
  });
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const cancelTranasctionsRequest = useRef(null);

  const loadData = async () => {
    if (cancelTranasctionsRequest.current) {
      cancelTranasctionsRequest.current.cancel(
        "Operation canceled due to new request."
      );
    }

    cancelTranasctionsRequest.current = axios.CancelToken.source();
    setLoading(true);

    const query = {
      limit: pagination?.perPage,
      offset: (pagination?.page - 1) * pagination?.perPage,
      filterBy: "status",
      filterValue: "Success",
    };
    if (search) {
      query.searchBy =
        "reason,paymentMode,status,account.firstName,account.lastName,account.email,account.phone";
      query.keyword = search;
    }

    await getTransactions(
      new URLSearchParams(query)?.toString(),
      cancelTranasctionsRequest.current.token
    )
      .then((res) => {
        if (res?.return) {
          const transactions = res?.data?.data;
          setOgData(transactions);
          setOrders(
            transactions.map((transaction) =>
              transactionsTableData(transaction)
            )
          );
          setPagination({ ...pagination, total: res?.data?.meta?.total || 1 });
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, [search, pagination.page, pagination.perPage, search]);

  return (
    <div className="w-full flex flex-col">
      <TransactionsTransactionStatSection timeFilter={timeFilter} />
      <TransactionTransactionsSearchSection
        search={search}
        setSearch={setSearch}
        {...{ timeFilter, setTimeFilter }}
      />
      <TransactionTransactionsList
        loading={loading}
        ogData={ogData}
        orders={orders}
      />
      <CommonPaginationSection
        page={pagination.page}
        perPage={pagination.perPage}
        total={pagination.total}
        callback={(page, perPage) => {
          setPagination({
            ...pagination,
            page,
            perPage,
          });
        }}
      />
    </div>
  );
}

export default TransactionTransactionsSection;
